/**
 * AppBlock — Block sites & Stay focused
 *
 * Declares a single web-accessible-resource, `block.html`, matched to every origin
 * (<all_urls>) with no `use_dynamic_url`. It is the interstitial shown when a blocked
 * site is opened, and it is reachable from any page at a fixed URL — so its presence is
 * conclusive for AppBlock, though there is only the one path to probe.
 *
 * Manifest verified against version 1.8.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lniombipmmhhighllijmcdncnefpjloi';

export const appblock: ExtensionDefinition = {
  id: ID,
  name: 'AppBlock - Block sites & Stay focused',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 50_000,
  notes:
    'Exposes a single static WAR (block.html) to every origin with no dynamic URL. One ' +
    'fetch is conclusive, though it is the only reachable path.',
  signals: [
    {
      id: 'war-block-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch block.html — the block interstitial, the extension\'s sole WAR, exposed ' +
        'to every origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'block.html'),
    },
  ],
};
